export enum VerificationStatus {
  PENDING = 'pending',
  DNS_FAILURE = 'dns_failure',
  CONNECTION_FAILED = 'connection_refused',
  UNDEFINED_FAILURE = 'failed',
  TIMEOUT = 'timeout',
  SUCCESS = 'ok',
  WARNING = 'warning',
  WRONG_CODE = 'wrong_code',
  MULTIPLE_CODES = 'multiple_codes',
}

export interface LastData {
  hoursSince: number | null;
  timestamp: number | null;
}

export interface TrackingCodeState {
  installed: boolean;
  isActive: boolean;
  lastData: LastData;
}

export interface VerificationResult {
  status: VerificationStatus;
}
